import logger from 'UTILS/logger';
import '../../styles/components/accordion.css';

/**
 * Handles accordion opening and closing
 *
 * Each accordion must have a wrapper around the header and panel with a class of "Accordion"
 * and a data-accordion="container".
 *
 * Each accordion header should contain data-accordion="header".
 *
 * Each accordion panel should contain data-accordion="panel".
 * @returns {void} void
 */
function handleAccordion(event) {
  try {
    const parent = event.target.closest('[data-accordion="container"]');
    const header = parent.querySelector('button');
    const panel = parent && parent.querySelector('[data-accordion="panel"]');

    if (!panel) return;
    const expanded = header.getAttribute('aria-expanded') === 'true';

    panel.setAttribute('aria-hidden', !!expanded);
    if (!expanded) {
      header.setAttribute('aria-expanded', !expanded);
    } else {
      setTimeout(() => header.setAttribute('aria-expanded', !expanded), 100); // ease the icon transition
    }
  } catch (err) {
    logger.error('handleAccordion', err);
  }
}

/**
 * IIFE sets event listeners for all accordions.
 *
 * Import it at theme level
 * @returns {void} void
 */
export default (function initAccordions() {
  const accordions = document.querySelectorAll('[data-accordion="container"]');
  if (accordions) {
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', handleAccordion);
    });
  }
})();
